import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SideNav } from 'bonfire-kindling';

import { ResponsiveSideNavContainer } from 'components';

const DashboardSideNav = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  return (
    <ResponsiveSideNavContainer>
      <ResponsiveSideNavContainer.Content>
        <SideNav
          sx={{
            boxShadow: 'none',
            flexGrow: 1,
            pt: theme => ({ xs: 0, sm: theme.spacing(5) }),
          }}
        >
          <SideNav.Back
            component={RouterLink}
            label={t('dashboard.sidenav.back')}
            to="/dashboard"
          />
          <SideNav.Item
            label={t('dashboard.wip.title')}
            to="/dashboard/wip"
            component={RouterLink}
            active={pathname === '/dashboard/wip'}
            icon="edit"
          />
          <SideNav.Item
            label={t('dashboard.contracts.title')}
            to="/dashboard/contracts"
            component={RouterLink}
            active={pathname === '/dashboard/contracts'}
            icon="file-contract"
          />
          <SideNav.Item
            label={t('dashboard.following.title')}
            to="/dashboard/following"
            component={RouterLink}
            active={pathname === '/dashboard/following'}
            icon="users"
          />
          <SideNav.Item
            label={t('dashboard.submitted.title')}
            to="/dashboard/submitted"
            component={RouterLink}
            active={pathname === '/dashboard/submitted'}
            icon="inbox"
          />
          <SideNav.Item
            label={t('dashboard.awarded.title')}
            to="/dashboard/awarded"
            component={RouterLink}
            active={pathname === '/dashboard/awarded'}
            icon="medal"
          />
          <SideNav.Item
            label={t('dashboard.missed.title')}
            to="/dashboard/missed"
            component={RouterLink}
            active={pathname === '/dashboard/missed'}
            icon="exclamation-circle"
          />
        </SideNav>
      </ResponsiveSideNavContainer.Content>
    </ResponsiveSideNavContainer>
  );
};

export default DashboardSideNav;
